import React, { Component } from 'react';
import ReactDOM from 'react-dom'
import classnames from 'classnames';

import './index.less'

export default class MaxBox extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    componentDidMount() {
        let html = document.getElementsByTagName('html');
        html[0].style.overflow = 'hidden';
    }

    componentWillUnmount() {
        let html = document.getElementsByTagName('html');
        html[0].style.overflow = 'auto';
    }

    render() {
        let { content, className, zIndex } = this.props
        return (
            ReactDOM.createPortal(
                <section
                    className={classnames('maxbox', className)}
                    style={{ zIndex }}
                >
                    {content}
                </section>,
                document.querySelector('body'),
            )
        )
    }
}

